export default __webpack_public_path__ + "static/media/cws-workwear-logo.b03bcbcd.png";